// extracted by mini-css-extract-plugin
export default {"cancelBtn":"CancelButton_cancelBtn__jNrRw"};